import axiosClient from "./axios";


const token = localStorage.getItem('token');

const uploadImage = async options => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    const config = {
        headers: {
            "content-type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
        onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            // setProgress(percent);
            // if (percent === 100) {
            //     setTimeout(() => setProgress(0), 1000);
            // }
            onProgress({ percent: (event.loaded / event.total) * 100 });
        }
    };
    fmData.append("image", file);
    try {
        const res = await axiosClient.post(
            "/uploadfile",
            fmData,
            config
        );
        onSuccess("Ok");
        console.log("server res: ", res);
    } catch (err) {
        console.log("Eroor: ", err);
        const error = new Error("Some error");
        onError({ err });
    }
};
export default uploadImage